module.exports = __webpack_public_path__ + "img/car_00020.0cbb4d99.jpg";